import { ApiError } from '@app/api/errors';
import { ReportContext } from '@app/components/reports/types';
import { useGetSalesReport } from '@shared/api/hooks/reports/reports';
import { OperationReportsSalesResultsRetrieveQueryResult } from '@shared/api/lib/operation-reports/operation-reports';
import { createContext, useContext } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

const SalesReportResultContext =
  createContext<ReportContext<OperationReportsSalesResultsRetrieveQueryResult> | null>(
    null
  );

export function useSalesReportResult() {
  return useContext(
    SalesReportResultContext
  ) as ReportContext<OperationReportsSalesResultsRetrieveQueryResult>;
}

export default function SalesReportContextProvider() {
  const { pathname } = useLocation();
  const params = useParams();
  const report_uuid = params.report_uuid;

  const {
    data: reportResult,
    status: reportResultStatus,
    error: reportResultError,
  } = useGetSalesReport(report_uuid!);

  const context: ReportContext<OperationReportsSalesResultsRetrieveQueryResult> =
    {
      result: reportResult!,
      resultStatus: reportResultStatus,
      resultError: reportResultError as ApiError,
      downloadMode: pathname.endsWith('/download'),
    };

  return (
    <SalesReportResultContext.Provider value={context}>
      <Outlet />
    </SalesReportResultContext.Provider>
  );
}
